import { haversineKm } from "@/lib/geo";
import type { RegionConfig } from "@/lib/regions";

export interface NearestSpot {
  regionId: string;
  /** Break ID of the nearest break (used as camera ID), null if no cameras */
  cameraId: string | null;
}

/**
 * Find the nearest region and camera to a lat/lon by checking all breaks.
 * Returns the region ID and break/camera ID of the closest break with a camera.
 */
export function findNearestRegion(
  lat: number,
  lon: number,
  regions: Record<string, RegionConfig>,
): NearestSpot | null {
  let bestRegionId: string | null = null;
  let bestCameraId: string | null = null;
  let bestDist = Infinity;

  for (const [regionId, config] of Object.entries(regions)) {
    for (const brk of config.breaks) {
      const d = haversineKm(lat, lon, brk.lat, brk.lon);
      if (d < bestDist) {
        bestDist = d;
        bestRegionId = regionId;
        bestCameraId = brk.cameras.length > 0 ? brk.id : null;
      }
    }
  }

  if (!bestRegionId) return null;
  return { regionId: bestRegionId, cameraId: bestCameraId };
}
